import React from 'react';
import HomepageNav from '../components/HomepageNav';
import MobileNav from '../components/MobileNav';
import Footer from '../components/Footer';
import './Datenschutz.css';

const Datenschutz = () => {
  return (
    <div className="datenschutz-page">
      <HomepageNav />
      <MobileNav />
      <main className="datenschutz-page__content">
        <h1 className="datenschutz-page__title">Datenschutzerklärung</h1>
        <p className="datenschutz-page__stand">Stand: September 2025</p>
        
        <div className="datenschutz-page__intro">
          <p>
            Der Schutz Ihrer personenbezogenen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten daher ausschließlich auf Grundlage der anwendbaren Rechtsvorschriften (insb. DSGVO, DSG, TKG 2021). Nachfolgend informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung im Rahmen dieser Website.
          </p>
        </div>

        <section className="datenschutz-page__section">
          <h2 className="datenschutz-page__section-title">1. Verantwortliche Stelle</h2>
          <div className="datenschutz-page__contact-info">
            <p><strong>Nintschew & Partner Steuer- und Wirtschaftsberatung GmbH & Co KG</strong></p>
            <p>Andreas-Huger-Gasse 6/1/49, 1220 Wien</p>
            <p>Telefon: +43 1 288 07 44</p>
            <p>E-Mail: office@nintschew-partner.at</p>
            <p>Web: https://www.nintschew-partner.at/</p>
            <p>Datenschutzanfragen: a.nintschew@nintschew-partner.at</p>
            <p>Datenschutzbeauftragter: Andrei Nintschew</p>
          </div>
        </section>

        <section className="datenschutz-page__section">
          <h2 className="datenschutz-page__section-title">2. Zwecke, Kategorien und Rechtsgrundlagen</h2>
          <p>Wir verarbeiten personenbezogene Daten, die Sie uns beim Besuch der Website oder im Rahmen der Kontaktaufnahme bereitstellen, zu folgenden Zwecken:</p>
          <ul className="datenschutz-page__list">
            <li>Bereitstellung der Website (IT-Betrieb, Sicherheit/Abwehr von Angriffen, Verfügbarkeitsmessung)</li>
            <li>Beantwortung von Anfragen über Kontaktformulare, E-Mail oder Telefon</li>
            <li>Terminvereinbarung über die Website</li>
            <li>Newsletter/Events (nach vorheriger Einwilligung)</li>
            <li>Bewerbungen über bereitgestellte Kanäle</li>
            <li>Reichweitenmessung/Webanalyse (sofern Sie zuvor eingewilligt haben)</li>
          </ul>
          <p><strong>Rechtsgrundlagen:</strong> Art 6 Abs 1 lit b DSGVO (Vertrag/vertragliche Anbahnung), Art 6 Abs 1 lit f DSGVO (berechtigtes Interesse an sicherem, effizienten Website-Betrieb und Kommunikation), Art 6 Abs 1 lit a DSGVO iVm § 165 TKG 2021 (Einwilligung für Cookies/Tracking/Marketing), Art 6 Abs 1 lit c DSGVO (rechtliche Verpflichtungen, z. B. Aufbewahrungspflichten).</p>
        </section>

        <section className="datenschutz-page__section">
          <h2 className="datenschutz-page__section-title">3. Bereitstellung der Website & Server-Logs</h2>
          <p>Beim Zugriff auf unsere Seiten werden technisch notwendige Daten automatisiert verarbeitet (u. a. IP-Adresse [gekürzt, wenn möglich], Datum/Uhrzeit, angeforderte Ressource, Browser/OS, Referrer, Provider). Diese Verarbeitung dient der technischen Auslieferung, Stabilität und IT-Sicherheit und erfolgt auf Basis unseres berechtigten Interesses (Art 6 Abs 1 lit f DSGVO). Server-Logs werden ca. 14 Tage gespeichert und anschließend gelöscht, sofern keine längere Aufbewahrung zur Aufklärung von Sicherheitsvorfällen erforderlich ist.</p>
          <p><strong>Hosting/Content-Delivery:</strong> Unsere Website wird bei einem Hosting-Anbieter mit Serverstandorten in der EU betrieben. Mit diesem besteht ein Auftragsverarbeitungsvertrag gem. Art 28 DSGVO. Bitte durch den IT-Dienstleister prüfen, ob zusätzlich ein Content-Delivery-Network (CDN) eingesetzt wird.</p>
        </section>

        <section className="datenschutz-page__section">
          <h2 className="datenschutz-page__section-title">4. Kontaktformulare & Kommunikation</h2>
          <p>Wenn Sie per Formular, E-Mail oder Telefon Kontakt mit uns aufnehmen, verarbeiten wir Ihre Angaben (Name, Kontaktdaten, Anliegen, Firmendaten) zum Zweck der Bearbeitung und für etwaige Anschlussfragen. Diese Daten werden nicht ohne Ihre Einwilligung weitergegeben, sofern dies nicht zur Bearbeitung erforderlich ist oder rechtliche Pflichten bestehen.</p>
          <p><strong>Speicherdauer:</strong> Korrespondenz wird für 6 Monate nach Abschluss der Anfrage aufbewahrt; bei Mandatsbeziehung gelten gesetzliche Aufbewahrungsfristen (idR 7 Jahre, gem. BAO/UGB).</p>
        </section>

        <section className="datenschutz-page__section">
          <h2 className="datenschutz-page__section-title">5. Terminvereinbarung</h2>
          <p>Über die Website können Sie direkt Termine mit uns vereinbaren. Dabei verarbeiten wir die von Ihnen angegebenen Daten (z. B. Name, Kontaktdaten, gewünschter Termin, Anliegen) zur Durchführung der Terminbuchung und ggf. zur Bestätigung/Erinnerung.</p>
          <p><strong>Speicherdauer:</strong> Daten zur Terminvereinbarung werden nach Durchführung des Termins 6 Monate aufbewahrt, sofern keine längere Aufbewahrung erforderlich ist.</p>
        </section>

        <section className="datenschutz-page__section">
          <h2 className="datenschutz-page__section-title">6. Newsletter</h2>
          <p>Sie haben die Möglichkeit, über unsere Website einen Newsletter zu abonnieren. Dafür benötigen wir Ihre E-Mail-Adresse und Ihre Einwilligung. Diese können Sie jederzeit mit Wirkung für die Zukunft widerrufen (Abmeldelink im Newsletter oder Mitteilung an uns).</p>
          <p><strong>Speicherdauer:</strong> Ihre Daten bleiben gespeichert, solange Sie den Newsletter beziehen. Nach Abmeldung werden die Daten gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.</p>
        </section>

        <section className="datenschutz-page__section">
          <h2 className="datenschutz-page__section-title">7. Bewerbungen</h2>
          <p>Für Bewerbungen verarbeiten wir die von Ihnen übermittelten Daten ausschließlich zur Auswahl geeigneter Kandidat:innen. Rechtsgrundlagen sind § 26 DSG, Art 6 Abs 1 lit b DSGVO und – soweit erforderlich – Ihre Einwilligung (Art 6 Abs 1 lit a DSGVO).</p>
          <p><strong>Speicherdauer:</strong> Bewerbungsdaten werden nach Abschluss des Verfahrens 7 Monate aufbewahrt; bei Einwilligung zur Evidenzhaltung 18 Monate.</p>
        </section>

        <section className="datenschutz-page__section">
          <h2 className="datenschutz-page__section-title">8. Cookies, Consent-Banner & ähnliche Technologien</h2>
          <p>Wir verwenden technisch notwendige Cookies für den Betrieb der Website. Alle weiteren Cookies (z. B. Statistik/Marketing) setzen wir nur mit Ihrer Einwilligung über unser Consent-Banner. Ihre Einwilligungen können Sie jederzeit mit Wirkung für die Zukunft widerrufen ("Cookie-Einstellungen" am Seitenfuß).</p>
          <p><strong>Cookie-Kategorien:</strong></p>
          <ul className="datenschutz-page__list">
            <li>Notwendig: z. B. Session-ID, Consent-Status</li>
            <li>Statistik: z. B. pseudonyme Reichweitenmessung</li>
            <li>Komfort/Marketing: z. B. eingebettete Karten/Fonts/Video, Retargeting</li>
          </ul>
        </section>

        <section className="datenschutz-page__section">
          <h2 className="datenschutz-page__section-title">9. Webanalyse</h2>
          <p>Wir setzen zur Analyse der Nutzung unserer Website ein datenschutzkonformes Webanalyse-Tool ein (z. B. Matomo oder Google Analytics 4). Die Verarbeitung erfolgt nur nach Ihrer Einwilligung.</p>
        </section>

        <section className="datenschutz-page__section">
          <h2 className="datenschutz-page__section-title">10. Eingebettete Inhalte & Drittanbieter</h2>
          <p>Unsere Website bindet externe Inhalte ein (z. B. Karten-, Schriftarten- und Video-Dienste). Dabei werden – je nach Dienst – Nutzungsdaten an Drittanbieter übermittelt. Diese Einbindung erfolgt erst nach Ihrer Einwilligung im Consent-Banner. Informationen zu den jeweiligen Anbietern, Datenkategorien und Speicherdauern finden Sie in den Cookie-Einstellungen.</p>
        </section>

        <section className="datenschutz-page__section">
          <h2 className="datenschutz-page__section-title">11. Empfänger & Auftragsverarbeiter</h2>
          <p>Wir übermitteln Daten nur, soweit dies erforderlich ist, an: IT-/Hosting-/Wartungsdienstleister, Anbieter von Consent-Management, Webanalyse; Kommunikations- und Dokumentendienstleister (z. B. E-Mail, Videokonferenz, Newsletter); Bewerbungs-/Karriere-Tools (falls eingesetzt); Behörden und Gerichte bei gesetzlicher Verpflichtung.</p>
          <p>Mit Dienstleistern schließen wir Auftragsverträge nach Art 28 DSGVO; diese verarbeiten Daten ausschließlich nach Weisung.</p>
        </section>

        <section className="datenschutz-page__section">
          <h2 className="datenschutz-page__section-title">12. Datenübermittlungen in Drittländer</h2>
          <p>Eine Übermittlung in Staaten außerhalb der EU/des EWR findet nur statt, wenn entweder ein Angemessenheitsbeschluss der EU-Kommission (z. B. EU-US DPF) besteht, Sie ausdrücklich eingewilligt haben oder geeignete Garantien iSd Art 46 DSGVO vorliegen (z. B. Standardvertragsklauseln, zusätzliche technische Maßnahmen).</p>
        </section>

        <section className="datenschutz-page__section">
          <h2 className="datenschutz-page__section-title">13. Speicherdauer</h2>
          <p>Wir verarbeiten personenbezogene Daten nur so lange, wie es für den jeweiligen Zweck erforderlich ist bzw. wie es gesetzliche Aufbewahrungspflichten vorsehen.</p>
        </section>

        <section className="datenschutz-page__section">
          <h2 className="datenschutz-page__section-title">14. Ihre Rechte</h2>
          <p>Sie haben – bei Vorliegen der gesetzlichen Voraussetzungen – das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung, Widerspruch, Datenübertragbarkeit sowie das Recht, erteilte Einwilligungen jederzeit zu widerrufen.</p>
          <p>Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt, können Sie sich bei uns oder bei einer Aufsichtsbehörde beschweren. In Österreich ist dies die Österreichische Datenschutzbehörde.</p>
        </section>

        <section className="datenschutz-page__section">
          <h2 className="datenschutz-page__section-title">15. Sicherheit</h2>
          <p>Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein (u. a. Zugriffsbeschränkungen, Verschlüsselung, Protokollierung, Backup-Konzepte), um Daten gegen Manipulation, Verlust oder unbefugten Zugriff zu schützen.</p>
        </section>

        <section className="datenschutz-page__section">
          <h2 className="datenschutz-page__section-title">16. Pflicht zur Bereitstellung</h2>
          <p>Die Bereitstellung bestimmter Daten (z. B. Kontaktangaben bei Anfragen, Newsletter-E-Mail-Adresse, Bewerbungsunterlagen) ist für die Bearbeitung erforderlich. Ohne diese Daten kann eine Bearbeitung u. U. nicht erfolgen.</p>
        </section>

        <section className="datenschutz-page__section">
          <h2 className="datenschutz-page__section-title">17. Änderungen dieser Erklärung</h2>
          <p>Wir passen diese Datenschutzerklärung an, wenn neue Services, Technologien oder Rechtsgrundlagen dies erfordern. Es gilt die jeweils hier veröffentlichte aktuelle Fassung.</p>
        </section>

        <section className="datenschutz-page__section">
          <h2 className="datenschutz-page__section-title">18. Aufsichtsbehörde & Beschwerderecht</h2>
          <div className="datenschutz-page__contact-info">
            <p><strong>Österreichische Datenschutzbehörde</strong></p>
            <p>Barichgasse 40–42, 1030 Wien, Österreich</p>
            <p>Telefon: +43 1 52 152-0</p>
            <p>E-Mail: dsb@dsb.gv.at</p>
            <p>Web: https://www.dsb.gv.at/</p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Datenschutz;
